<script setup>
import { useI18n } from 'vue-i18n';
import BranchNodeBase from './BranchNodeBase.vue';

const props = defineProps({
  id: { type: String, required: true },
  data: { type: Object, required: true },
  selected: { type: Boolean, default: false },
});

const { t } = useI18n();
</script>

<template>
  <BranchNodeBase
    :id="props.id"
    :data="data"
    :selected="selected"
    icon="i-lucide-git-branch"
    :type-label="t('SOPS.NODES.DECISION')"
    accent-class="bg-n-amber-9/15 text-n-amber-11"
  />
</template>
